export function MobileLogo() {
  return (
    <div className="md:hidden flex flex-col items-center mb-12">
      <div className="logo-circle scale-75 mb-4 shadow-sm">
        <svg
          className="w-12 h-12"
          fill="none"
          viewBox="0 0 40 40"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M5 20C5 20 10 15 20 20C30 25 35 20 35 20"
            stroke="white"
            strokeLinecap="round"
            strokeWidth="3"
          />
        </svg>
      </div>
      <h1 className="font-headline-md text-headline-md text-on-surface text-center px-4">
        Studio Dietetico Stucchi
      </h1>
    </div>
  );
}
